export default "__VITE_ASSET__Bf6q4KeN__"